import React from 'react';
import { cx } from '../utils/cx';
import styles from './IPhone.module.css';

// iPhone 17 Pro Max mockup. --w = the body's short edge; every other
// dimension (bezel, screen radius, Dynamic Island) is a CSS calc() off it.
// Pass `screenshots` for a scroll-snap carousel, or `children` for custom
// screen content (e.g. the fake iOS home screen used in the hero).
export default function IPhone({ width = 340, landscape = false, big = false, className, id, children }) {
  return (
    <div
      id={id}
      className={cx(styles.iphone, landscape && styles.land, big && styles.big, className)}
      style={{ '--w': `${width}px` }}
    >
      <div className={styles.screen}>
        <div className={styles.island} />
        {children}
        <div className={styles.sheen} />
      </div>
    </div>
  );
}
